import React from 'react';
import { useIntl } from 'react-intl';

import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';

import MediaPage from './MediaPage';

export default function useMediaPage() {
  const intl = useIntl();
  return {
    Component: MediaPage,
    tab: {
      label: intl.formatMessage({
        id: 'tab.videos',
        defaultMessage: 'Videos',
      }),
      slug: 'media',
      icon: <OndemandVideoIcon />,
    },
  };
}
